var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEncryptedLock = function SvgEncryptedLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 11 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M11 7c0-.772-.617-1.4-1.375-1.4h-.687V3.5C8.938 1.57 7.395 0 5.5 0S2.063 1.57 2.063 3.5v2.1h-.688C.617 5.6 0 6.228 0 7v5.6c0 .772.617 1.4 1.375 1.4h8.25c.758 0 1.375-.628 1.375-1.4zM3.438 3.5c0-1.158.925-2.1 2.062-2.1s2.063.942 2.063 2.1v2.1H3.438z"
  })));
};
export default SvgEncryptedLock;